import { settings } from '@dabble/app';
import BookOptions from '@dabble/plugins/export/components/BookOptions.svelte';

settings.configure('novel_book', {
  exportFileTypes: ['word', 'text', 'html', 'google'],
  exportStyles: ['manuscript', 'dabble'],
  exportOptions: {
    word: { BookOptions },
    google: { BookOptions },
    html: { BookOptions },
  },
});
settings.configure('novel_part', {
  exportFileTypes: ['word', 'text', 'html', 'google'],
  exportStyles: ['manuscript', 'dabble'],
});
settings.configure('novel_chapter', {
  exportFileTypes: ['word', 'text', 'html', 'google'],
  exportStyles: ['manuscript', 'dabble'],
});
settings.configure('novel_scene', {
  exportFileTypes: ['word', 'text', 'html', 'google'],
  exportStyles: ['manuscript', 'dabble'],
});

settings.configure('novel_book_scenes', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
  exportDescriptions: true,
});
settings.configure('novel_plot', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
  exportDescriptions: true,
});
settings.configure('novel_plot_line', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
  exportDescriptions: true,
});

settings.configure('novel_folder', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
});
settings.configure('novel_page', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
});

settings.configure('novel_cast', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
});
settings.configure('novel_character', {
  exportFileTypes: ['word', 'google'],
  exportStyles: ['dabble'],
});
